<template>
  <div class="life-page">
    <section class="life-panel">
      <div class="life-panel__head">
        <h2 class="life-panel__title">码牌查询</h2>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openEditor()">新增码牌</el-button>
      </div>
      <div class="life-filter">
        <el-input v-model="filters.plateNo" placeholder="码牌编号" clearable style="width: 180px" @keyup.enter.native="search" />
        <el-select v-model="filters.status" placeholder="状态" clearable style="width: 130px">
          <el-option v-for="s in statusOptions" :key="s.value" :label="s.label" :value="s.value" />
        </el-select>
        <el-select v-model="filters.mediaType" placeholder="介质" clearable style="width: 110px">
          <el-option label="QR" value="QR" />
          <el-option label="NFC" value="NFC" />
          <el-option label="QR+NFC" value="QR+NFC" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
    </section>

    <section class="life-panel">
      <div class="life-panel__head">
        <h2 class="life-panel__title">码牌列表</h2>
      </div>
      <el-table v-loading="loading" :data="rows" border>
        <el-table-column prop="plateNo" label="码牌编号" min-width="140" />
        <el-table-column label="介质" width="90" align="center">
          <template slot-scope="scope">
            <el-tag size="small" type="info">{{ scope.row.mediaType || 'QR' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="batchNo" label="批次号" width="130" />
        <el-table-column prop="plateType" label="类型" width="100" />
        <el-table-column prop="ownerCompanyName" label="归属物业" min-width="140" />
        <el-table-column prop="communityName" label="绑定小区" width="140" />
        <el-table-column label="场景" width="150" align="center">
          <template slot-scope="scope">{{ sceneName(scope.row.sceneCode) }}</template>
        </el-table-column>
        <el-table-column prop="displayName" label="展示名称" width="140" />
        <el-table-column prop="installLocation" label="安装位置" width="140" />
        <el-table-column prop="entryUrl" label="入口链接" min-width="200" />
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="statusTag(scope.row.status)" size="small">
              {{ scope.row.statusName }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170" />
        <el-table-column label="操作" width="170" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status !== 'SCRAPPED'" type="text" size="small" @click="openEditor(scope.row)">编辑</el-button>
            <el-button v-if="scope.row.status === 'INACTIVE'" type="text" size="small" @click="handleChangeStatus(scope.row, 'ASSIGNED')">分配</el-button>
            <el-button v-if="scope.row.status === 'ASSIGNED' || scope.row.status === 'BOUND'" type="text" size="small" @click="handleChangeStatus(scope.row, 'DISABLED')">停用</el-button>
            <el-button v-if="scope.row.status === 'DISABLED'" type="text" size="small" @click="handleChangeStatus(scope.row, 'ASSIGNED')">恢复</el-button>
            <el-dropdown trigger="click" @command="(cmd) => handleCmd(cmd, scope.row)" style="margin-left: 4px">
              <el-button type="text" size="small">更多<i class="el-icon-arrow-down el-icon--right" /></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="scope.row.status !== 'SCRAPPED'" command="scrap" icon="el-icon-delete">报废</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="life-pagination" :current-page.sync="page.current" :page-size="page.size"
        :page-sizes="[10, 20, 50]" :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="changeSize" @current-change="load" />
    </section>

    <el-dialog :title="form.plateId ? '编辑码牌' : '新增码牌'" :visible.sync="editorVisible" width="480px" @closed="onDialogClosed">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="码牌编号" prop="plateNo">
          <el-input v-model="form.plateNo" maxlength="64" placeholder="印刷编号" />
        </el-form-item>
        <el-form-item label="介质">
          <el-select v-model="form.mediaType" style="width: 100%">
            <el-option label="QR (二维码)" value="QR" />
            <el-option label="NFC" value="NFC" />
            <el-option label="QR+NFC" value="QR+NFC" />
          </el-select>
        </el-form-item>
        <el-form-item label="批次号">
          <el-input v-model="form.batchNo" maxlength="64" />
        </el-form-item>
        <el-form-item label="类型">
          <el-input v-model="form.plateType" maxlength="12" placeholder="如：缴费、访客、报修" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" maxlength="256" placeholder="用途说明" />
        </el-form-item>
        <el-form-item label="归属物业公司">
          <el-select v-model="form.ownerCompanyId" placeholder="请选择归属物业" filterable clearable style="width: 100%">
            <el-option v-for="c in companyOptions" :key="c.storeId" :label="c.name" :value="c.storeId" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio label="INACTIVE">库存</el-radio>
            <el-radio label="ASSIGNED">待激活</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editorVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listPlates, savePlate, updatePlate } from '@/api/aggregateCode/aggregateCodeApi'
import { getStoreList } from '@/api/store/storeApi'
import { getDict } from '@/api/community/communityApi'

function getNowStr() {
  const d = new Date()
  const pad = n => String(n).padStart(2, '0')
  return `${d.getFullYear()}${pad(d.getMonth()+1)}${pad(d.getDate())}${pad(d.getHours())}${pad(d.getMinutes())}`
}

function emptyForm() {
  return { plateId: '', plateNo: getNowStr(), mediaType: 'QR', batchNo: '', plateType: '', remark: '', ownerCompanyId: '', status: 'INACTIVE' }
}

export default {
  name: 'AggregateCodePlatformPlateList',
  data() {
    return {
      loading: false, saving: false, editorVisible: false,
      rows: [],
      companyOptions: [], sceneOptions: [],
      statusOptions: [
        { label: '库存', value: 'INACTIVE' },
        { label: '已分配', value: 'ASSIGNED' },
        { label: '已绑定', value: 'BOUND' },
        { label: '已停用', value: 'DISABLED' },
        { label: '已报废', value: 'SCRAPPED' }
      ],
      filters: { plateNo: '', status: '', mediaType: '' },
      page: { current: 1, size: 10, total: 0 },
      form: emptyForm(),
      rules: {
        plateNo: [{ required: true, message: '请输入码牌编号', trigger: 'blur' }]
      }
    }
  },
  created() { this.load(); this.loadCompanies(); this.loadSceneDict() },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await listPlates({ ...this.filters, page: this.page.current, row: this.page.size })
        this.rows = res.data || []
        this.page.total = Number(res.total || 0)
      } catch (error) {
        this.$message.error(error.message || '加载码牌列表失败')
      } finally { this.loading = false }
    },
    search() { this.page.current = 1; this.load() },
    reset() { this.filters = { plateNo: '', status: '', mediaType: '' }; this.search() },
    changeSize(size) { this.page.size = size; this.load() },
    async loadCompanies() {
      try {
        const res = await getStoreList({ page: 1, row: 200 })
        this.companyOptions = res.data || []
      } catch (_) { /* ignore */ }
    },
    async loadSceneDict() {
      try { this.sceneOptions = await getDict('aggregate_code_binding', 'scene_code') || [] } catch (_) { /* ignore */ }
    },
    sceneName(code) {
      const s = this.sceneOptions.find(o => o.name === code)
      return s ? (s.description || s.name) : code
    },
    statusTag(s) {
      return { INACTIVE: 'info', ASSIGNED: 'warning', BOUND: 'success', DISABLED: 'danger', SCRAPPED: 'danger' }[s] || 'info'
    },
    openEditor(row) {
      if (row) {
        this.form = { ...row, ownerCompanyId: row.ownerCompanyId || '' }
      } else {
        this.form = emptyForm()
      }
      this.editorVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    onDialogClosed() {
      this.$refs.formRef && this.$refs.formRef.resetFields()
    },
    handleCmd(cmd, row) {
      if (cmd === 'scrap') this.handleChangeStatus(row, 'SCRAPPED')
    },
    async handleChangeStatus(row, targetStatus) {
      const labelMap = { ASSIGNED: row.status === 'DISABLED' ? '恢复' : '分配', DISABLED: '停用', SCRAPPED: '报废' }
      const label = labelMap[targetStatus]
      const extra = targetStatus === 'SCRAPPED' ? '，报废后不可恢复！' : ''
      try {
        await this.$confirm('确认' + label + '码牌「' + row.plateNo + '」？' + extra, '操作确认', { type: 'warning' })
        await updatePlate({ plateId: row.plateId, status: targetStatus })
        this.$message.success(label + '成功')
        this.load()
      } catch (error) {
        if (error !== 'cancel') this.$message.error(error.message || '操作失败')
      }
    },
    submit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.saving = true
        try {
          if (this.form.plateId) {
            await updatePlate(this.form)
            this.$message.success('码牌已更新')
          } else {
            const res = await savePlate(this.form)
            const url = res.data && res.data.entryUrl
            this.$message.success('码牌已创建' + (url ? '，入口：' + url : ''))
          }
          this.editorVisible = false
          this.load()
        } catch (error) {
          this.$message.error(error.message || '保存失败')
        } finally { this.saving = false }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './life.scss';
</style>
